import { Column, Index, JoinColumn, ManyToOne } from 'typeorm';
import { Entity } from '../../decorators';
import { BaseEntity } from './base.entity';
import { OrderEntity } from './order.entity';

/** One line of a quote as it stood at a revision. */
export interface QuoteRevisionLineModel {
	itemId: number | null;
	itemExternalId: string | null;
	description: string | null;
	quantity: number;
	price: number | null;
	total: number | null;
}

/**
 * PD-17328 — a revision of a quote: its number, when, what changed (in the
 * rep's words), and the total and lines as they stood, so the opportunity
 * shows how the quote moved over a pursuit. A quote is an order row with the
 * Quote status; its lines are order_detail rows.
 *
 * SM1 exposure: none (a new table).
 */
@Index('quote_revision__order_revision', ['fkOrderId', 'revisionNumber'], { unique: true })
@Entity('quote_revision')
export class QuoteRevisionEntity extends BaseEntity {
	@Column('int', { name: 'fk_order__id', unsigned: true })
	public fkOrderId!: number;

	@Column('int', { name: 'revisionNumber', unsigned: true })
	public revisionNumber!: number;

	@Column('decimal', { name: 'total', precision: 13, scale: 2, nullable: true })
	public total!: string | null;

	@Column('varchar', { name: 'note', length: 500, nullable: true })
	public note!: string | null;

	@Column('json', { name: 'lines', nullable: true })
	public lines!: Array<QuoteRevisionLineModel> | null;

	@ManyToOne(() => OrderEntity, { onDelete: 'CASCADE', onUpdate: 'RESTRICT' })
	@JoinColumn([{ name: 'fk_order__id', referencedColumnName: 'id' }])
	public order!: OrderEntity;
}
